module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi44MjIgNS41ODhsMy4xNDMgMy4wNk05LjEwOCA1LjU4OGwtMy4xNDMgMy4wNk01Ljk2NSA4LjY0N1YxIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMS40IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48cGF0aCBkPSJNLjk2NSAxMmgxMCIgc3Ryb2tlPSIjMjFDOEZGIiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Contest/footer-link-rules.svg
// module id = 420
// module chunks = 0